module.exports = __webpack_public_path__ + "img/85.98fbf29a.jpg";